// extracted by mini-css-extract-plugin
export default {"title":"TextContent_title__MwKdv","text":"TextContent_text__ANu2C"};